import stores from "cd-eft/models/Stores";
import { DynamicCrossSectionTableStore } from "cd-eft/models/Stores/DynamicProfile/CrossSection/DynamicCrossSectionTableStore";
import { action, observable } from "mobx";
import { GroundPoint } from '../BreaklineTools/model/GroundPoint';
import { appConfig } from 'cd-eft/config/AppConfig';
import { EngineeringMapService } from 'cd-eft/framework/mapServices/EngineeringMapServices';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as SETAPI from 'cd-eft/services/eftSetApi';
import { DynamicCrossSectionProfileStore } from "cd-eft/models/Stores/DynamicProfile/CrossSection/DynamicCrossSectionProfileStore";
import { getDimensionsForImage } from "cd-eft/utils/imageUtils";


const surveyEngStore = stores.AppStore.surveyEngineeringStore;
const threeCrossSectionStore = stores.AppStore.threeCrossSectionDesignStore;
const designStore = stores.AppStore.designStore;
const waterwayDesignStore = stores.AppStore.waterwayDesignStore;

export interface IProfileControlsForm {
    profileControlsPopUpActive: boolean;
    checked: {
      showFineGrid: boolean;
      previews: boolean;
    };
    input: {
      fineGrid: number;
      bufferWidth: number;
    };
  }
  
  export const profileControlsFormDefault: IProfileControlsForm = {
    profileControlsPopUpActive: false,
    checked: {
      showFineGrid: false,
      previews: false,
    },
    input: {
      fineGrid: Math.trunc(10.0),
      bufferWidth: 10.0,
    },
  };

export class ThreeCrossSectionVM {
    private tableStore: DynamicCrossSectionTableStore;
    private profileStore1: DynamicCrossSectionProfileStore;
    public profileStore2: DynamicCrossSectionProfileStore;
    private profileStore3: DynamicCrossSectionProfileStore;
    @observable props;
    currentObject;
    waterwayObject;
    @observable isSuccessful: boolean = false;
    @observable error = false;
    @observable errorMsg = '';
    @observable thresholdSize: boolean = false;
    @observable replaceTheOldestImage: boolean = false;
    @observable saveReportClicked: boolean = false;
    @observable imageSavedSuccessful: boolean = false;
    @observable imageSavedError: boolean = false;
    private dragWatchHandle;
    private resizeWatchHandle1;
    private resizeWatchHandle2;
    private resizeWatchHandle3;
    private resizeWatchHandle4;
    private resizeWatchHandle5;
    private resizeWatchHandle6;
    private resizeWatchHandle7;
    private resizeWatchHandle8;
    private _initialWaterwayReachStation;
    private sampleInterval: number;
    private stationsOnly: boolean = false;
    private customizedStation: boolean = false;
    @observable stationIncrement: number;
    @observable stationName1 = '';
    @observable stationName2 = '';
    @observable stationName3 = '';
    private changedInputValue: boolean = false;
    private previousValue = '';
    @observable isProfileFirstVisible:boolean = true;
    @observable isProfileMiddleVisible:boolean = true;
    @observable isProfileThirdVisible:boolean = true;
    @observable profileControlsForm: IProfileControlsForm = profileControlsFormDefault;
    @observable savedProfileControlsForm: IProfileControlsForm = profileControlsFormDefault;
    private profileEditsPreviewed: boolean = false;

    @observable formValidation = {
        formErrors: {
            fineGrid: '',
            bufferWidth: '',
        },
        fineGridValid: true,
        bufferWidthValid: true,
        formValid: true
    }

    constructor(props: any) {
        this.props = props;

        this.currentObject = threeCrossSectionStore.threeCrossSectionObject;
        this.currentObject.sessionId = designStore.projectsStore.currentSessionId;
        this.waterwayObject = waterwayDesignStore.waterwayDesignObject;

        this.tableStore = props.profileTableStore;
        this.tableStore.setStore = surveyEngStore;
        this.tableStore.crossSectionStore = threeCrossSectionStore;
        this.tableStore.CurrentObject = threeCrossSectionStore.threeCrossSectionObject;
        this.isSuccessful = false;

        this.profileStore1 = props.profileStoreRef1;
        this.profileStore2 = props.profileStoreRef2;
        this.profileStore3 = props.profileStoreRef3;

        this.sampleInterval = 2;
        this.stationIncrement = 50;
    }

    @action.bound onMount() {
        const dragElement = document.getElementById('tcs-header');
        this.dragWatchHandle = dragElement?.addEventListener('mousedown', this.handleMouseDownDrag);

        const resizers = document.querySelectorAll(".tcs-resizer");
        let count: number = 1;

        for (const resizer of resizers) {
            switch (count) {
                case 1:
                    this.resizeWatchHandle1 = resizer.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
                    break;
                case 2:
                    this.resizeWatchHandle2 = resizer.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
                    break;
                case 3:
                    this.resizeWatchHandle3 = resizer.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
                    break;
                case 4:
                    this.resizeWatchHandle4 = resizer.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
                    break;
                case 5:
                    this.resizeWatchHandle5 = resizer.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
                    break;
                case 6:
                    this.resizeWatchHandle6 = resizer.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
                    break;
                case 7:
                    this.resizeWatchHandle7 = resizer.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
                    break;
                case 8:
                    this.resizeWatchHandle8 = resizer.addEventListener('mousedown', this.handleMouseDownResize.bind(this));
                    break;
            }

            count ++;
        }
    }

    @action.bound onUnmount() {
        this.dragWatchHandle?.remove();
        this.resizeWatchHandle1?.remove();
        this.resizeWatchHandle2?.remove();
        this.resizeWatchHandle3?.remove();
        this.resizeWatchHandle4?.remove();
        this.resizeWatchHandle5?.remove();
        this.resizeWatchHandle6?.remove();
        this.resizeWatchHandle7?.remove();
        this.resizeWatchHandle8?.remove();
        designStore.tcs1HorizontalStretchFactor = undefined;
        designStore.tcs2HorizontalStretchFactor = undefined;
        designStore.tcs3HorizontalStretchFactor = undefined;
    }

    private handleMouseDownDrag(e) {
        const crossSectionElement = document.getElementById('three-crosssection-container');
        if (crossSectionElement) {
            document.body.style.userSelect = 'none';
            const offsetX = e.clientX - crossSectionElement.offsetLeft;
            const offsetY = e.clientY - crossSectionElement.offsetTop;
            
            const handleMouseMove = (e) => {
                const left = e.clientX - offsetX;
                const top = e.clientY - offsetY;
                const designDiv = document.getElementById('design-container');
                const maxX = designDiv!.clientWidth - crossSectionElement!.offsetWidth;
                const maxY = designDiv!.clientHeight - crossSectionElement!.offsetHeight;

                crossSectionElement!.style.left = `${Math.min(maxX, Math.max(0, left))}px`;
                crossSectionElement!.style.top = `${Math.min(maxY, Math.max(0, top))}px`;
            }
            
            const handleMouseUp = () => {
                window.removeEventListener('mousemove', handleMouseMove);
                window.removeEventListener('mouseup', handleMouseUp);
                document.body.style.userSelect = 'auto';
            }

            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }
    }

    private handleMouseDownResize(e) {
        const crossSectionElement = document.getElementById('three-crosssection-container');
        const designDiv = document.getElementById('design-container');
        
        if (crossSectionElement && designDiv) {
            const rect = crossSectionElement.getBoundingClientRect();
            const minWidth = Number(crossSectionElement.style.minWidth.replace('px',''));
            const minHeight = Number(crossSectionElement.style.minHeight.replace('px',''));
            const startWidth = rect.width;
            const startHeight = rect.height;
            const startX = e.clientX;
            const startY = e.clientY;
            const startLeft = crossSectionElement.offsetLeft;
            const startTop = crossSectionElement.offsetTop;
            const currentResizer = e.target;
            
            const handleMouseMoveResize = (e) => {
                document.body.style.userSelect = 'none';
                const deltaX = e.clientX - startX;
                const deltaY = e.clientY - startY;

                if (currentResizer.id === 'se-resizer') {
                    const width = startWidth + deltaX;
                    const height = startHeight + deltaY;
                    if (width > minWidth && startLeft + width <= designDiv.offsetWidth) {
                        crossSectionElement.style.width = width + 'px';
                    }
                    if (height > minHeight && startTop + height <= designDiv.offsetHeight) {
                        crossSectionElement.style.height = height + 'px';
                    }
                } else if (currentResizer.id === 'sw-resizer') {
                    const width = startWidth - deltaX;
                    const height = startHeight + deltaY;
                    const left = startLeft + deltaX;
                    if (width > minWidth && left >= 0) {
                      crossSectionElement.style.width = width + 'px';
                      crossSectionElement.style.left = left + 'px';
                    }
                    if (height > minHeight && startTop + height <= designDiv.offsetHeight) {
                        crossSectionElement.style.height = height + 'px';
                      }
                } else if (currentResizer.id === 'ne-resizer') {
                    const width = startWidth + deltaX;
                    const height = startHeight - deltaY;
                    const top = startTop + deltaY;
                    if (width > minWidth && startLeft + width <= designDiv.offsetWidth) {
                        crossSectionElement.style.width = width + 'px';
                    }
                    if (height > minHeight && top >= 0) {
                        crossSectionElement.style.height = height + 'px';
                        crossSectionElement.style.top = top + 'px';
                    }
                } else if (currentResizer.id === 'nw-resizer') {
                    const width = startWidth - deltaX;
                    const height = startHeight - deltaY;
                    const top = startTop + deltaY;
                    const left = startLeft + deltaX;
                    if (width > minWidth && left >= 0) {
                        crossSectionElement.style.width = width + 'px';
                        crossSectionElement.style.left = left + 'px';
                    }
                    if (height > minHeight && top >= 0) {
                        crossSectionElement.style.height = height + 'px';
                        crossSectionElement.style.top = top + 'px';
                    }
                } else if (currentResizer.id === 'n-resizer') {
                    const height = startHeight - deltaY;
                    const top = startTop + deltaY;
                    if (height > minHeight && top >= 0) {
                        crossSectionElement.style.height = height + 'px';
                        crossSectionElement.style.top = top + 'px';
                    }
                } else if (currentResizer.id === 's-resizer') {
                    const height = startHeight + deltaY;
                    if (height > minHeight && startTop + height <= designDiv.offsetHeight) {
                        crossSectionElement.style.height = height + 'px';
                    }
                } else if (currentResizer.id === 'e-resizer') {
                    const width = startWidth + deltaX;
                    if (width > minWidth && startLeft + width <= designDiv.offsetWidth) {
                        crossSectionElement.style.width = width + 'px';
                    }
                } else if (currentResizer.id === 'w-resizer') {
                    const width = startWidth - deltaX;
                    const left = startLeft + deltaX;
                    if (width > minWidth && left >= 0) {
                        crossSectionElement.style.width = width + 'px';
                        crossSectionElement.style.left = left + 'px';
                    }
                }
            }
                
            const handleMouseUpResize = () => {
                window.removeEventListener('mousemove', handleMouseMoveResize);
                window.removeEventListener('mouseup', handleMouseUpResize);
                document.body.style.userSelect = 'auto';    
                this.redrawProfiles(this.profileControlsForm.input.bufferWidth);  
            }

            window.addEventListener('mousemove', handleMouseMoveResize);
            window.addEventListener('mouseup', handleMouseUpResize);
        }               
    }

    private redrawProfiles(bufferWidth){
        designStore.tcs1HorizontalStretchFactor = undefined;
        designStore.tcs2HorizontalStretchFactor = undefined;
        designStore.tcs3HorizontalStretchFactor = undefined;
        this.profileStore1.redrawProfiles(Number(bufferWidth));
        this.profileStore2.redrawProfiles(Number(bufferWidth));
        this.profileStore3.redrawProfiles(Number(bufferWidth));
    }

    private redrawGrids(gridValue) {
        this.profileStore1.updateGridValues(Number(gridValue));
        this.profileStore2.updateGridValues(Number(gridValue));
        this.profileStore3.updateGridValues(Number(gridValue));
    }

    handleRowMouseEnter(data) {
        const point = new GroundPoint();
        point.id = data.stationName;
        point.name = data.stationName;
        point.x = data.x;
        point.y = data.y;
        point.z = data.z;
        point.wkid = appConfig.tempHardCodes.wkid;
        EngineeringMapService.instance?.trackPoint(point);
    }

    handleRowMouseLeave() {
        EngineeringMapService.instance?.unTrackLast();
    }

    @action.bound onClickCancelCrossSec = () => {
        designStore.hideCrossSectionToolbar = true;
        designStore.hideThreeCrossSection = true;
        designStore.crossSectionDrawingComplete = false;
    };

    @action.bound async onClickSaveCrossSec(profileView: any) {
        designStore.setLoader("Saving the Report...");
        try {
            // Get the extent of the mapView
            const extent = profileView.extent;

            const dimensions = getDimensionsForImage(extent, profileView);

            // Take a screenshot of the profileView with the specified parameters
            const screenshot = await profileView.takeScreenshot({
                width: dimensions.imageWidth,
                height: dimensions.imageHeight,
                area: dimensions.area,
                format: 'png',
                ignorePadding: true
            });

            const stationName = this.stationName2;
            const [firstPoint, lastPoint] = await this.profileStore2.getCrossSectionDesignVertices();

            //todo code here.
            const twoDimensionalGeometry = {
                profileOrCrossSectionXY: [
                    { "id": 1, "x": firstPoint[0].toString(), "y": firstPoint[1].toString() },
                    { "id": 2, "x": lastPoint[0].toString(), "y": lastPoint[1].toString() }
                ]
            }
            //payload for crosssection
            const payloadCS = {
                designElementId: waterwayDesignStore.alignedDesignElementId,
                designElementTypeId: waterwayDesignStore.currentWaterwayDesignElementTypeId 
                ? waterwayDesignStore.currentWaterwayDesignElementTypeId 
                : (waterwayDesignStore.waterwayType === "Lined Waterway" ? 19 : 7),
                profileImageBase64String: screenshot.dataUrl,
                profileOrCrossSection: "CrossSection",
                stationId: stationName,
                structureMapImageBase64String: undefined,
                structureProfilesId: 0,
                twoDimensionalGeometryJson: JSON.stringify(twoDimensionalGeometry)
            };
            const response = await SETAPI.StructureProfileController.generateUpdateStructureCrossSectionImageUsingPOST(payloadCS);
            if (response.data.status === "Success") {
                this.imageSavedSuccessful = true;
                setTimeout(() => {
                    this.imageSavedSuccessful = false;
                }, 3000);
            }
        } catch (error) {
            this.imageSavedError = true;
            this.errorMsg = (error as Error).message;
        } finally {
            designStore.setLoader("");
        }
    }

    // takeProfileViewScreenshot
    // Code for screenshot that checks threshold limit has been removed due to changed requirements.
    // See git commit 9b5e822bd7b1e7dc899c79c08422a859d8b53602 

    private get initialWaterwayReachStation() {
        if (!this._initialWaterwayReachStation) {
            this._initialWaterwayReachStation = threeCrossSectionStore.initialWaterwayReachStation;
        }
        return this._initialWaterwayReachStation;
    }
    @action.bound async initThreeCrossSectionProfiles() {
        this.profileStore1.raiseStartLengthyProcessEvent(true);
        this.profileStore2.raiseStartLengthyProcessEvent(true);
        this.profileStore3.raiseStartLengthyProcessEvent(true);
        this.profileStore3.disableButtonEvent(true);
        this.loadWaterwayReachStations();
        let reachID;
        switch(true) {
            case waterwayDesignStore.threeCrossSectionTableViewToggle:
                reachID = waterwayDesignStore.threeCrossSectionReachID;
                break;
            case this.currentObject.waterwayReachStations.findIndex((station) => station.reachId === 'R-1') === -1:
                reachID = 'R-last';
                break;
            default:
                reachID = 'R-1';
                break;
        }
        this.currentObject.mainReachStation = this.currentObject.waterwayReachStations.findIndex((station) => station.reachId === reachID);
        this.profileStore1.initProfileKeys();
        this.profileStore2.initProfileKeys();
        this.profileStore3.initProfileKeys();
        this.setStationNames(
            waterwayDesignStore.threeCrossSectionTableViewToggle ? waterwayDesignStore.threeCrossSectionStation : this.currentObject.waterwayReachStations[this.currentObject.mainReachStation].stationName,  
            this.currentObject.mainReachStation
        );
        this.generateThreeCrossSectionProfiles(this.currentObject.mainReachStation);
        waterwayDesignStore.threeCrossSectionTableViewToggle = false;
    }
    
    @action.bound async jumpToStation(stationName: string) {
        this.profileStore1.raiseStartLengthyProcessEvent(true);
        this.profileStore2.raiseStartLengthyProcessEvent(true);
        this.profileStore3.raiseStartLengthyProcessEvent(true);
        this.profileStore3.disableButtonEvent(true);    
            if (!this.currentObject.waterwayReachStations || this.currentObject.waterwayReachStations.length === 0) {
                this.loadWaterwayReachStations();
            }
            const mainIndex = this.currentObject.waterwayReachStations.findIndex((station) => station.reachId === waterwayDesignStore.threeCrossSectionReachID);
            this.currentObject.mainReachStation = mainIndex;
            this.setStationNames(stationName, mainIndex);
            await this.generateThreeCrossSectionProfiles(mainIndex, stationName);
            this.customizedStation = false;
    }

    @action.bound moveBackStation() {
        this.imageSavedSuccessful = false; // To clear success message
        this.profileStore1.raiseStartLengthyProcessEvent(true);
        this.profileStore2.raiseStartLengthyProcessEvent(true);
        this.profileStore3.raiseStartLengthyProcessEvent(true);
        this.profileStore3.disableButtonEvent(true);
        this.currentObject.mainReachStation = this.currentObject.mainReachStation - (!this.customizedStation ? 1 : 0.5);
        this.setStationNames(
            this.currentObject.waterwayReachStations[this.currentObject.mainReachStation].stationName, 
            this.currentObject.mainReachStation
        );
        this.generateThreeCrossSectionProfiles(this.currentObject.mainReachStation);
        this.customizedStation = false;
    }

    @action.bound moveNextStation() {
        this.imageSavedSuccessful = false;
        this.profileStore1.raiseStartLengthyProcessEvent(true);
        this.profileStore2.raiseStartLengthyProcessEvent(true);
        this.profileStore3.raiseStartLengthyProcessEvent(true);
        this.profileStore3.disableButtonEvent(true);
        this.currentObject.mainReachStation = this.currentObject.mainReachStation + (!this.customizedStation ? 1 : 0.5);
        this.setStationNames(
            this.currentObject.waterwayReachStations[this.currentObject.mainReachStation].stationName, 
            this.currentObject.mainReachStation
        );
        this.generateThreeCrossSectionProfiles(this.currentObject.mainReachStation);
        this.customizedStation = false;
    }

    @action.bound downIncrement() {
        this.profileStore1.raiseStartLengthyProcessEvent(true);
        this.profileStore2.raiseStartLengthyProcessEvent(true);
        this.profileStore3.raiseStartLengthyProcessEvent(true);
        this.profileStore3.disableButtonEvent(true);
        this.stationIncrement = this.stationIncrement - 5;
        this.setStationNames(this.stationName2, this.currentObject.mainReachStation);
        this.generateThreeCrossSectionProfiles(this.currentObject.mainReachStation, this.stationName2);
    }

    @action.bound upIncrement() {
        this.profileStore1.raiseStartLengthyProcessEvent(true);
        this.profileStore2.raiseStartLengthyProcessEvent(true);
        this.profileStore3.raiseStartLengthyProcessEvent(true);
        this.profileStore3.disableButtonEvent(true);
        this.stationIncrement = this.stationIncrement + 5;
        this.setStationNames(this.stationName2, this.currentObject.mainReachStation);
        this.generateThreeCrossSectionProfiles(this.currentObject.mainReachStation, this.stationName2);
    }

    @action.bound async handleInputOnChange(event: any) {
        const { value, name } = event.target;
        if (name === 'stationName2') {
            this.stationName2 = value;
            this.changedInputValue = true;
        } else if (name === 'stationIncrement') {
            this.stationIncrement = parseInt(value, 10);
            this.changedInputValue = true;
        }
    }

    @action.bound async handleInputOnBlur(event: any) {
        if (!this.changedInputValue) {
            return;
        }
        this.changedInputValue = false;
    
        const { value, name } = event.target;
        
        if (name === 'stationName2' && this.validateStationName(value)) {
            const mainStation = this.formatWaterwayStation(value);
            this.currentObject.mainReachStation = this.setMainIndex(mainStation);
            this.setStationNames(mainStation, this.currentObject.mainReachStation);
            this.generateThreeCrossSectionProfiles(this.currentObject.mainReachStation, mainStation);
        } else if (name === 'stationIncrement') {
            this.stationIncrement = parseInt(value, 10);
            this.setStationNames(this.stationName2, this.currentObject.mainReachStation); 
            this.generateThreeCrossSectionProfiles(this.currentObject.mainReachStation);
        }
    }

    @action.bound async handleInputOnFocus(event: any) {
        const { value, name } = event.target;
        if (name == "stationIncrement") {
            this.previousValue = value;
        }
    }

    // @action.bound generateCrossSectionProfiles() {
    //     // Start lengthy process event for all profile stores
    //     this.profileStore1.raiseStartLengthyProcessEvent(true);
    //     this.profileStore2.raiseStartLengthyProcessEvent(true);
    //     this.profileStore3.raiseStartLengthyProcessEvent(true);
    //     this.profileStore3.disableButtonEvent(true);
    
    //     // Set station names and generate cross-section profiles
    //     this.setStationNames(this.stationName2, this.currentObject.mainReachStation);
    //     this.generateThreeCrossSectionProfiles(this.currentObject.mainReachStation, this.stationName2);
    // }

    private loadWaterwayReachStations() {
        this.currentObject.waterwayReachStations = [];
        const stations = this.currentObject.waterwayReachStations;
        this.waterwayObject.waterwayDesignStations.map((station, index) => {
            const newStation = { ...this.initialWaterwayReachStation };
            if (station.endStation) {
                newStation.index = index - 1;
                newStation.stationName = station.endStation;
                newStation.station = station.endStation.replace("+", "");
                newStation.reachId = station.reachId;
                if (index === this.waterwayObject.waterwayDesignStations.length - 2) {
                    newStation.reachId = 'R-last';
                }
                stations.push(newStation);
            }
        });
    }

    private async generateThreeCrossSectionProfiles(mainIndex: number, mainStation?: any) {
        designStore.tcs1HorizontalStretchFactor = undefined;
        designStore.tcs2HorizontalStretchFactor = undefined;
        designStore.tcs3HorizontalStretchFactor = undefined;
        if (this.currentObject.waterwayReachStations[mainIndex]) {
            this.profileStore1.resetProfile();
            this.profileStore2.resetProfile();
            this.profileStore3.resetProfile();

                if (!this.stationsOnly) {
                    const response = await this.getReachProfilesData(this.currentObject.waterwayReachStations[mainIndex], this.sampleInterval, this.stationIncrement);

                    if (response && response.structureCrossSectionResponses) {
                        const profiles = response.structureCrossSectionResponses;
                        if (profiles[0]) {
                            const stationListLength = profiles[0]?.designProfile?.stationDTOList?.length ?? 0;
                            this.isProfileFirstVisible= (stationListLength < 2)?false:true;
                            this.profileStore1.generateReachProfile(profiles[0]);
                        }
                        if (profiles[1]) {
                            const stationListLength = profiles[1]?.designProfile?.stationDTOList?.length ?? 0;
                            this.isProfileMiddleVisible= (stationListLength < 2 || (waterwayDesignStore.endGradeLength > 0 && this.currentObject.waterwayReachStations[mainIndex].stationName === this.currentObject.waterwayReachStations[this.currentObject.waterwayReachStations.length-1].stationName)) ? false : true;
                            this.profileStore2.generateReachProfile(profiles[1], true);
                        }
                        if (profiles[2]) {
                            const stationListLength = profiles[2]?.designProfile?.stationDTOList?.length ?? 0;
                            this.isProfileThirdVisible= (stationListLength < 2)?false:true;
                            this.profileStore3.generateReachProfile(profiles[2]);
                        }
                        this.profileStore3.disableButtonEvent(false);
                    }
                } else {    // for the scenario that increment = 0
                    if (mainIndex - 1 >= 1) {
                        const response = await this.getReachProfilesData(this.currentObject.waterwayReachStations[mainIndex - 1], this.sampleInterval, this.stationIncrement);
                        if (response && response.structureCrossSectionResponses) {
                            this.profileStore1.generateReachProfile(response.structureCrossSectionResponses[0]);
                        }
                    }
                    if (mainIndex >= 1 && mainIndex <= this.currentObject.waterwayReachStations.length - 1) {
                        const response = await this.getReachProfilesData(this.currentObject.waterwayReachStations[mainIndex], this.sampleInterval, this.stationIncrement);
                        if (response && response.structureCrossSectionResponses) {
                            this.profileStore2.generateReachProfile(response.structureCrossSectionResponses[0], true);
                        }
                    }
                    if (mainIndex + 1 <= this.currentObject.waterwayReachStations.length - 1) {
                        const response = await this.getReachProfilesData(this.currentObject.waterwayReachStations[mainIndex + 1], this.sampleInterval, this.stationIncrement);
                        if (response && response.structureCrossSectionResponses) {
                            this.profileStore3.generateReachProfile(response.structureCrossSectionResponses[0]);
                        }
                    }
                    this.profileStore3.disableButtonEvent(false);
                }
        } else if (mainStation && this.customizedStation) {
            await this.generateCustomProfiles(mainIndex, mainStation);
        }
    }

    private async generateCustomProfiles(mainIndex: number, mainStation: any) {
        this.profileStore1.resetProfile();
        this.profileStore2.resetProfile();
        this.profileStore3.resetProfile();
        let station;
        if (mainIndex === -1) {
            const R0Index = this.currentObject.waterwayReachStations.findIndex((station) => station.reachId === 'R-0');
            const lastReachIndex = this.currentObject.waterwayReachStations.findIndex((station) => station.reachId === 'R-last');
            if ((Number(this.stationName2.replace('+', '') < this.currentObject.waterwayReachStations[R0Index].station) && Number(this.stationName3.replace('+', '')) < this.currentObject.waterwayReachStations[R0Index].station)
            || (Number(this.stationName2.replace('+', '') > this.currentObject.waterwayReachStations[lastReachIndex].station) && Number(this.stationName1.replace('+', '')) > this.currentObject.waterwayReachStations[lastReachIndex].station)) {
                this.isProfileFirstVisible = false;
                this.isProfileMiddleVisible = false;
                this.isProfileThirdVisible = false;
                return;                    
            } else {
                if (Number(mainStation.replace('+', '')) < this.currentObject.waterwayReachStations[R0Index].station) {
                    station = this.currentObject.waterwayReachStations[R0Index + 1];
                    this.currentObject.mainReachStation = R0Index - 0.5;
                } else if (Number(mainStation.replace('+', '')) > this.currentObject.waterwayReachStations[lastReachIndex].station) {
                    station = this.currentObject.waterwayReachStations[lastReachIndex];
                    this.currentObject.mainReachStation = lastReachIndex + 0.5;
                }
            }
        } else {
            station = this.currentObject.waterwayReachStations[mainIndex - 0.5];
        }

        const response = await this.getReachProfilesData(station, this.sampleInterval, this.stationIncrement, mainStation);

        if (response && response.structureCrossSectionResponses) {
            const profiles = response.structureCrossSectionResponses;
            if (profiles[0]) {
                if (profiles[0]?.designProfile?.stationDTOList?.length && profiles[0]?.designProfile?.stationDTOList?.length  < 2) {
                    this.isProfileFirstVisible = false;
                    
                } else {
                    this.profileStore1.generateReachProfile(profiles[0]);
                    this.isProfileFirstVisible = true;
                }
            }
            if (profiles[1]) {
                if (profiles[1]?.designProfile?.stationDTOList?.length && profiles[1]?.designProfile?.stationDTOList?.length  < 2) {
                    this.isProfileMiddleVisible = false;
                } else {
                    this.profileStore2.generateReachProfile(profiles[1], true);
                    this.isProfileMiddleVisible = true;
                }
            }
            if (profiles[2]) {
                if (profiles[2]?.designProfile?.stationDTOList?.length && profiles[2]?.designProfile?.stationDTOList?.length  < 2) {
                    this.isProfileThirdVisible = false;
                } else {
                    this.profileStore3.generateReachProfile(profiles[2]);
                    this.isProfileThirdVisible = true;
                }
            }
            this.profileStore3.disableButtonEvent(false);
        }
    }

    private async getReachProfilesData(station: any, sampleInterval: number, stationIncrement: number, mainStation?: any) {
        try {
            let stationDistance: number;
            if (this.customizedStation && mainStation) {    // customized station
                stationDistance = Number(mainStation.replace('+', ''));
            } else {
                // To avoid the out of boundary case caused by rounding
                if (station.index == 0) stationDistance = Number(station.station) + 0.05;
                else if (station.index == this.currentObject.waterwayReachStations.length - 1) stationDistance = Number(station.station) - 0.05;
                else stationDistance = Number(station.station);
            }
            const params = {
                sessionUuid: designStore.projectsStore.currentSessionId,
                alignedElementDesignParametersId: waterwayDesignStore.alignedDesignElementId,
                station: stationDistance,
                sampleInterval: sampleInterval,
                stationIncrement: stationIncrement,
                displayCurrentStationOnly: this.stationsOnly,
            }
            const response = (await SETAPI.StructureProfileController.generateAlignedStructureCrossSectionsUsingPOST(params)).data;

            //Set the value of last Station from neighborStations
            if(station.station === this.currentObject.waterwayReachStations[this.currentObject.waterwayReachStations.length - 1].station){
                const lastNeighborStation = parseFloat(response.neighborStations?.[2] !== undefined ? response.neighborStations[2].toString() : "").toFixed(1);
                this.stationName3 = this.formatWaterwayStation(lastNeighborStation);
            }
                   
            return response;
        } catch (error) {
            if ((error as any).response && (error as any).response.data && (error as any).response.data.errorMessage) {
                const errorCode = (error as any).response.data.originalErrorCode
                if (errorCode == 'CS_2') {
                    await MessageCenter.addErrorFromCode(errorCode)
                } else {
                    await MessageCenter.addWarningFromCode(errorCode)
                }
            } else {
                MessageCenter.addError((error as Error).message);
            }
            this.profileStore1.raiseStartLengthyProcessEvent(false);
            this.profileStore2.raiseStartLengthyProcessEvent(false);
            this.profileStore3.raiseStartLengthyProcessEvent(false);
            this.profileStore3.disableButtonEvent(false);
        }
    }

    private setStationNames(mainStation: string, mainIndex: number) {
        if (!this.stationsOnly) {
            const station = Number(mainStation.replace('+', ''));
            this.stationName1 = (station - this.stationIncrement) >= 0 ? this.formatWaterwayStation(Number((station - this.stationIncrement).toFixed(1))) : '0+00';
            this.stationName2 = this.formatWaterwayStation(Number(station.toFixed(1)));
            this.stationName3 = this.formatWaterwayStation(Number((station + this.stationIncrement).toFixed(1)));
        } else {
            if (!this.customizedStation) {
                this.stationName1 = mainIndex - 1 >= 1 ? this.currentObject.waterwayReachStations[mainIndex - 1].stationName : '0+00';
                this.stationName2 = this.currentObject.waterwayReachStations[mainIndex].stationName;
                this.stationName3 = mainIndex + 1 <= this.currentObject.waterwayReachStations.length - 1 ? this.currentObject.waterwayReachStations[mainIndex + 1].stationName : '';
            } else {
                this.stationName1 = this.currentObject.waterwayReachStations[mainIndex - 0.5].stationName;
                this.stationName2 = mainStation;
                this.stationName3 = this.currentObject.waterwayReachStations[mainIndex + 0.5].stationName;
            }
        } 
    }

    private setMainIndex(mainStationName: string) {
        const mainStation = mainStationName.replace('+', '');
        for (let i = 1; i < this.currentObject.waterwayReachStations.length - 1; i++) {
            if (mainStation == this.currentObject.waterwayReachStations[i].station) {
                this.customizedStation = false;
                return i;
            } else if (mainStation > this.currentObject.waterwayReachStations[i].station && mainStation < this.currentObject.waterwayReachStations[i + 1].station) {
                // else if (mainStation > this.currentObject.waterwayReachStations[i].station
                // && (waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[i+1] && mainStation < this.currentObject.waterwayReachStations[i + 1].station) 
                // && waterwayDesignStore.waterwayDesignObject.waterwayDesignStations[i+1].reachId !== 'END') {
                this.customizedStation = true;
                return i + 0.5;
            }
        }
        this.customizedStation = true;
        return -1;
    }

    private validateStationName(name: any) {
        if (/^(\d+\+\d{2}(\.\d)?|\d+(\.\d)?)$/.test(name)) {    // valid station name should be 0+00/0+00.0 or 123/123.1 format
            return true;
        } else {
            MessageCenter.addErrorFromCode('WDT_101');
            return false;
        }
    }

    private formatWaterwayStation(name: any) {
        if (/^\d+\+\d{2}(\.\d)?$/.test(name)) {
            return name;
        } else if (/^\d+(\.\d)?$/.test(name)) {
            const parts = name.toString().split(".");
            let integerPart = parts[0];
            const decimalPart = parts.length > 1 ? "." + parts[1] : "";
        
            while(integerPart.length < 3) {
                integerPart = "0" + integerPart;
            }
        
            const formattedStation = integerPart.slice(0, -2) + "+" + integerPart.slice(-2) + decimalPart;
            return formattedStation;
        }
    }

    @action.bound openViewControls() {
        MessageCenter.clearMessages();
        if (this.profileControlsForm.profileControlsPopUpActive) {
            this.handleCancelProfileSettings();
        } else {
            this.profileControlsForm = JSON.parse(JSON.stringify(this.savedProfileControlsForm));
            this.profileControlsForm.profileControlsPopUpActive = true;
        }
    }

    @action.bound previewProfileSettingsHandler() {
        this.profileControlsForm.checked.previews = !this.profileControlsForm.checked.previews;
        if (this.profileControlsForm.checked.previews) {
            if (this.profileControlsForm.input.bufferWidth !== this.savedProfileControlsForm.input.bufferWidth){
                this.redrawProfiles(this.profileControlsForm.input.bufferWidth);
                this.profileEditsPreviewed = true;
            }
            if (this.profileControlsForm.checked.showFineGrid && this.profileControlsForm.input.fineGrid !== this.savedProfileControlsForm.input.fineGrid) {
                this.redrawGrids(this.profileControlsForm.input.fineGrid);
                this.profileEditsPreviewed = true;
            }
        } else {
            if (this.profileEditsPreviewed) {
                this.resetProfilesToSavedControls();
            }
        }
    }

    @action.bound toggleFineGrid() {
        this.profileControlsForm.checked.showFineGrid = !this.profileControlsForm.checked.showFineGrid;
    }

    @action.bound handleCancelProfileSettings() {
        // reset parameters
        if (this.profileEditsPreviewed) {
            this.resetProfilesToSavedControls();
        }
        this.profileControlsForm = JSON.parse(JSON.stringify(this.savedProfileControlsForm));
        this.profileControlsForm.checked.previews = false
        this.profileControlsForm.profileControlsPopUpActive = false;
    }
    
    @action.bound async handleSaveProfileSettings() {
        this.profileEditsPreviewed = false;
        this.profileControlsForm.profileControlsPopUpActive = false;
        this.profileControlsForm.checked.previews = false
        this.redrawProfiles(this.profileControlsForm.input.bufferWidth);
        const gridValue = this.profileControlsForm.checked.showFineGrid ? this.profileControlsForm.input.fineGrid : 0;
        this.redrawGrids(gridValue);
        this.savedProfileControlsForm = JSON.parse(JSON.stringify(this.profileControlsForm));
    }

    private resetProfilesToSavedControls() {
        this.profileEditsPreviewed = false;
        this.redrawProfiles(this.savedProfileControlsForm.input.bufferWidth);
        const gridValue = this.savedProfileControlsForm.checked.showFineGrid ? this.savedProfileControlsForm.input.fineGrid : 0;
        this.redrawGrids(gridValue);
    }
}